import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

/**
 * Legacy styled title component (preserved for backwards compatibility)
 * @deprecated Use responsive typography styles from components/styles.ts instead
 */
export const BannerTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.common.white,
  fontWeight: 600,

  [theme.breakpoints.down('sm')]: {
    fontSize: '1.1rem',
  },
}));

/**
 * Legacy styled subtitle component (preserved for backwards compatibility)
 * @deprecated Use responsive typography styles from components/styles.ts instead
 */
export const BannerSubtitle = styled(Typography)(({ theme }) => ({
  color: 'rgba(255, 255, 255, 0.9)',

  [theme.breakpoints.down('sm')]: {
    fontSize: '0.875rem',
  },
}));
